import { BehaviorSubject } from 'rxjs';
import { INotification } from '@molecules/Notifications/INotification';

/** Стэк уведомлений */
let notifications$$ = new BehaviorSubject<INotification[]>([]);

export const getNotifications$ = () => notifications$$;

export const resetNotifications$ = () => {
    if (notifications$$.closed) {
        notifications$$ = new BehaviorSubject<INotification[]>([]);
    }
};

/** Удалить уведомление */
export const removeNotification = (id?: string) => {
    if (notifications$$.closed || notifications$$.isStopped) {
        return;
    }

    let tmp = [...notifications$$.getValue()];

    if (tmp.length > 0) {
        if (id !== undefined) {
            tmp = tmp.filter((n: INotification) => n.id !== id);
        } else {
            tmp.shift();
        }

        notifications$$.next(tmp);
    }
};

/** Добавить уведомление */
export const sendNotification = (message: INotification, delay = 8000) => {
    if (notifications$$.closed || notifications$$.isStopped) {
        return;
    }

    const tmp = [...notifications$$.getValue()];

    tmp.push({
        ...message,
        id: message.id || Date.now().toString(),
    });

    notifications$$.next(tmp);

    setTimeout(() => {
        removeNotification(message.id);
    }, delay);
};
